import axiosInstance from './axiosInstance';

export const getPersonalizzazioni = () =>
    axiosInstance.get('/personalizzazioni').then(r => r.data);

export const savePersonalizzazioni = (voci) =>
    axiosInstance.post('/personalizzazioni', Array.isArray(voci) ? voci : [voci]).then(r => r.data);

export const deletePersonalizzazione = (chiave) =>
    axiosInstance.delete(`/personalizzazioni/${chiave}`).then(r => r.data);
